import BookDemoForm, { getServerSidePropsFunc } from '../bookafreehomedemo';
export default BookDemoForm;
export const getServerSideProps = getServerSidePropsFunc('/forbesbuddypetgroomingkit/book-a-demo');
